// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Av4x","content":"GlobalSearch_content__2f8Qm"};